

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityWarehouse_ManagedObject

class DBMappingEntityWarehouse_ManagedObject extends DBMappingEntity
{
}
